// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__ouYKB","upload":"Small_upload__3sDOs","imageWrap":"Small_imageWrap__3SQHn","removeBtn":"Small_removeBtn__3tcb4"};